// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React from 'react'
import './App.css'
import { BrowserRouter } from 'react-router-dom'
import SideNavigation from '../navigation/Navigation'
import Routing from '../Routing.js'
import Header from '../header/Header'
import Footer from '../footer/Footer'
import Provider from '../../shared/Provider'
import DashboardTour from '../tour/DashboardTour'
import config from '../../config/config'
import NavigationContext from '../../shared/contexts/NavigationContext'

// Function based component rendering the application and its components
function App() {
  const [mobileCollapsed, setMobileCollapsed] = React.useState(window.innerWidth <= 1024)
  
  React.useEffect(() => {
    document.title = config.appName;
  }, []);

  const mainClasses = mobileCollapsed ? 'med-content med-nav-mobile-collapsed' : 'med-content'

  return (
    <NavigationContext.Provider value={{ mobileCollapsed, setMobileCollapsed }}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <div className="med-page-wrapper">
          <Header />
          <SideNavigation mobileCollapsed={mobileCollapsed} setMobileCollapsed={setMobileCollapsed} />
          <main className={mainClasses}>
            <div className="med-content-wrapper">
              <Provider>
                <DashboardTour>
                  <Routing />
                </DashboardTour>
              </Provider>
            </div>
            <Footer />
          </main>
        </div>
      </BrowserRouter>
    </NavigationContext.Provider>
  )
}

export default App
